import React from 'react';
import { Route, Switch } from 'react-router';

import Campaign from '../Components/Campaign';

const routes = (
  <div className="campaign">
    <Campaign />
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/Routes/index.jsx